import { abortIfNotPermitted } from '../utils';

export default [
    {
        path: '/',
        component: () =>
            import(/* webpackChunkName: "customer-engagement" */ '@js/franchise_component/customer-engagement/customer-engagement-index.vue'),
        beforeEnter: (to, from, next) => {
            return abortIfNotPermitted(
                'franchise_view_customer_engagement',
                next,
            );
        },
    },
    {
        path: '/gamification',
        component: () =>
            import(/* webpackChunkName: "customer-engagement-gamification" */ '@js/franchise_component/customer-engagement/gamification/gamification-index.vue'),
        beforeEnter: (to, from, next) => {
            return abortIfNotPermitted(
                'franchise_view_customer_engagement',
                next,
            );
        },
    },
    {
        path: '/gamification/campaign/create',
        component: () =>
            import(/* webpackChunkName: "customer-engagement-gamification-campaign-form" */ '@js/franchise_component/customer-engagement/gamification/campaign/campaign-form.vue'),
        beforeEnter: (to, from, next) => {
            return abortIfNotPermitted(
                'franchise_manage_customer_engagement',
                next,
            );
        },
    },
    {
        path: '/gamification/campaign/:id',
        component: () =>
            import(/* webpackChunkName: "customer-engagement-gamification-campaign-form" */ '@js/franchise_component/customer-engagement/gamification/campaign/campaign-form.vue'),
        beforeEnter: (to, from, next) => {
            return abortIfNotPermitted(
                'franchise_manage_customer_engagement',
                next,
            );
        },
    },
    {
        path: '/gamification/game/create',
        component: () =>
            import(/* webpackChunkName: "customer-engagement-gamification-game-form" */ '@js/franchise_component/customer-engagement/gamification/game/game-form.vue'),
        beforeEnter: (to, from, next) => {
            return abortIfNotPermitted(
                'franchise_manage_customer_engagement',
                next,
            );
        },
    },
    {
        path: '/gamification/game/:id',
        component: () =>
            import(/* webpackChunkName: "customer-engagement-gamification-game-form" */ '@js/franchise_component/customer-engagement/gamification/game/game-form.vue'),
        beforeEnter: (to, from, next) => {
            return abortIfNotPermitted(
                'franchise_manage_customer_engagement',
                next,
            );
        },
    },
    {
        path: '/upsell',
        component: () =>
            import(/* webpackChunkName: "customer-engagement-upsell" */ '@js/franchise_component/customer-engagement/upsell/upsell-index.vue'),
        beforeEnter: (to, from, next) => {
            return abortIfNotPermitted(
                'franchise_view_customer_engagement',
                next,
            );
        },
    },
    {
        path: '/upsell/category/create',
        component: () =>
            import(/* webpackChunkName: "customer-engagement-upsell-category-form" */ '@js/franchise_component/customer-engagement/upsell/category/category-upsell-form.vue'),
        beforeEnter: (to, from, next) => {
            return abortIfNotPermitted(
                'franchise_manage_customer_engagement',
                next,
            );
        },
    },
    {
        path: '/upsell/category/:id',
        component: () =>
            import(/* webpackChunkName: "customer-engagement-upsell-category-form" */ '@js/franchise_component/customer-engagement/upsell/category/category-upsell-form.vue'),
        beforeEnter: (to, from, next) => {
            // View-only users may open the detail to read it; the Save button is
            // hidden for them and the update endpoint enforces MANAGE server-side.
            return abortIfNotPermitted(
                'franchise_view_customer_engagement',
                next,
            );
        },
    },
    {
        path: '/upsell/time/create',
        component: () =>
            import(/* webpackChunkName: "customer-engagement-upsell-time-form" */ '@js/franchise_component/customer-engagement/upsell/time/time-upsell-form.vue'),
        beforeEnter: (to, from, next) => {
            return abortIfNotPermitted(
                'franchise_manage_customer_engagement',
                next,
            );
        },
    },
    {
        path: '/upsell/time/:id',
        component: () =>
            import(/* webpackChunkName: "customer-engagement-upsell-time-form" */ '@js/franchise_component/customer-engagement/upsell/time/time-upsell-form.vue'),
        beforeEnter: (to, from, next) => {
            // View-only users may open the detail to read it; the Save button is
            // hidden for them and the update endpoint enforces MANAGE server-side.
            return abortIfNotPermitted(
                'franchise_view_customer_engagement',
                next,
            );
        },
    },
];
